import {
  isValidCPF,
  validateBirthday,
  validatePhone
} from '../utils/user-info-validation';

const getNotFoundHeaders = headers => {
  const requiredHeaders = [
    'name',
    'course',
    'area',
    'unit',
    'phone',
    'cpf',
    'birthday'
  ];

  const notFoundHeaders = requiredHeaders.filter(
    header => headers.indexOf(header) === -1
  );

  return notFoundHeaders;
};

const verifyUsersFields = usersList => {
  const newList = usersList.map(user => {
    let error = false;
    let fatalError = false;
    const errors = {};
    if (!user.name) {
      error = true;
      fatalError = true;
      errors.name = true;
    }
    if (!user.cpf || !isValidCPF(user.cpf)) {
      error = true;
      fatalError = true;
      errors.cpf = true;
    }
    if (!user.area) {
      error = true;
      fatalError = true;
      errors.area = true;
    }
    if (!user.course) {
      error = true;
      fatalError = true;
      errors.course = true;
    }
    if (!user.unit) {
      error = true;
      fatalError = true;
      errors.unit = true;
    }
    if (!user.phone || !validatePhone(user.phone)) {
      error = true;
      errors.phone = true;
    }
    if (!user.birthday || !validateBirthday(user.birthday)) {
      error = true;
      fatalError = true;
      errors.birthday = true;
    }
    return {
      ...user,
      error,
      fatalError,
      errors
    };
  });
  return newList;
};

function validateUsers(usersList) {
  // return [];
  const headers = Object.keys(usersList[0]);
  const headersNotFound = getNotFoundHeaders(headers);
  if (headersNotFound.length > 0) {
    return {
      error: true,
      type: 'headers',
      message: `Por favor, verifique se as colunas da planilha estão nomeadas corretamente. \n Cabeçalhos não encontrados: ${headers.map(
        h => `${h} `
      )}`
    };
  }
  const verifiedUsers = verifyUsersFields(usersList);
  return verifiedUsers;
}

export default { validateUsers };
